module.exports = __webpack_public_path__ + "assets/442bec78da4c4d66f1cfcd336f7b3cb4.mp3";